"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationContext = exports.EViewPort = void 0;
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable camelcase */
var react_1 = __importStar(require("react"));
var api_1 = require("Service/api");
var react_redux_1 = require("react-redux");
var EViewPort;
(function (EViewPort) {
    EViewPort[EViewPort["mobile"] = 0] = "mobile";
    EViewPort[EViewPort["desktop"] = 1] = "desktop";
})(EViewPort = exports.EViewPort || (exports.EViewPort = {}));
exports.ApplicationContext = react_1.default.createContext({
    name: 'Accall/io App',
    logoBase64: '',
    logoMimeType: '',
    pages: [],
    viewPort: EViewPort.desktop,
    navigationCollapsed: false,
    showTenantSwitch: true,
    showBreadcrumb: true,
    setViewPort: function (vp) { },
    toggleNavigationCollapsed: function () { },
});
exports.default = (function (_a) {
    var _b;
    var children = _a.children, pages = _a.pages, name = _a.name, logoBase64 = _a.logoBase64, logoMimeType = _a.logoMimeType, extraQueryParams = _a.extraQueryParams, extraTokenParams = _a.extraTokenParams, _c = _a.showBreadcrumb, showBreadcrumb = _c === void 0 ? true : _c, _d = _a.hideTenantSwitch, hideTenantSwitch = _d === void 0 ? false : _d;
    var _e = react_1.useState(EViewPort.desktop), viewPort = _e[0], setViewPort = _e[1];
    var _f = react_1.useState(false), navigationCollapsed = _f[0], setNavigationCollapsed = _f[1];
    var oidc = react_redux_1.useSelector(function (state) { return state.oidc; });
    // set access token globally for all axios requests
    api_1.Api.instance.axiosInstance.defaults.headers.Authorization = "Bearer " + ((_b = oidc.user) === null || _b === void 0 ? void 0 : _b.access_token);
    var toggleNavigationCollapsed = function () {
        if (viewPort === EViewPort.desktop) {
            setNavigationCollapsed(false);
        }
        else {
            setNavigationCollapsed(!navigationCollapsed);
        }
    };
    react_1.useEffect(function () {
        if (viewPort === EViewPort.desktop) {
            setNavigationCollapsed(false);
        }
        else {
            setNavigationCollapsed(true);
        }
    }, [viewPort]);
    var value = {
        name: name,
        logoBase64: logoBase64,
        logoMimeType: logoMimeType,
        pages: pages,
        viewPort: viewPort,
        navigationCollapsed: navigationCollapsed,
        showTenantSwitch: !hideTenantSwitch,
        showBreadcrumb: showBreadcrumb,
        extraQueryParams: extraQueryParams,
        extraTokenParams: extraTokenParams,
        setViewPort: setViewPort,
        toggleNavigationCollapsed: toggleNavigationCollapsed,
    };
    return react_1.default.createElement(exports.ApplicationContext.Provider, { value: value }, children);
});
//# sourceMappingURL=context.js.map